import axios from "axios";

export default {
  namespaced: true,
  state: {
    campaigns: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    campaignsMessage: ''
  },
  mutations: {
    CLEAR_MARKETCAMPAIGNS(state) {
      state.campaigns = [];
    },
    RECEIVED_MARKETCAMPAIGNS(state, payload) {
      state.campaigns = payload;
      state.isReceiving = false;
    },
    RECEIVING_MARKETCAMPAIGNS(state) {
      state.isReceiving = true;
    },
    RECEIVED_MARKETCAMPAIGN(state, payload) {
      state = Object.assign(state, {
        campaigns: [...state.campaigns, payload],
        isReceiving: false,
      })
    },
    RECEIVING_MARKETCAMPAIGN(state) {
      state.isReceiving = true;
    },
    UPDATED_MARKETCAMPAIGN(state, payload) {
      let index = state.campaigns.findIndex(campaign => campaign._id === payload._id);
      state = Object.assign(state, {
        campaigns: state.campaigns.map((campaign, i) => {
          if (i === index) {
            return Object.assign({}, campaign, payload);
          }
          return campaign;
        }),
        isUpdating: false,
        campaignsMessage: 'MarketCampaigns has been updating!',
      })
    },
    UPDATING_MARKETCAMPAIGN(state) {
      state.isUpdating = true;
    },
    DELETED_MARKETCAMPAIGN(state, payload) {
      console.log(payload._id);
      let indexToDelete = state.campaigns.findIndex(campaign => campaign._id === payload._id);
      console.log(indexToDelete);
      let campaigns = [...state.campaigns];
      campaigns.splice(indexToDelete, 1);
      state = Object.assign(state, {
        campaigns: [...campaigns],
        isDeleting: false,
        idToDelete: null,
        campaignsMessage: 'MarketCampaign has been Deleted!',
      });
    },
    DELETING_MARKETCAMPAIGN(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteMarketCampaignRequest({dispatch}, payload) {
      dispatch("deletingMarketCampaign", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/marketcampaign/' + payload._id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "delete", url: url, headers: headers})
      .then(response=>{
        console.log(response.data);
        dispatch("deleteMarketCampaign", response.data);
      })
      .catch(error=>{
        console.log(error.data);
      });
    },
    async deleteProjectCampaignRequest({dispatch}, payload) {
      try{
        dispatch("deletingMarketCampaign", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/marketcampaign/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deleteMarketCampaign", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertMarketCampaignRequest({dispatch}, payload) {
      dispatch("receivingMarketCampaigns");
      var token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/marketcampaign';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      
      let response = await axios({method: "post", url: url, headers: headers, data: data});
      dispatch("receiveMarketCampaign", response.data);
      return response.data;
    },
    async insertProjectCampaignRequest({dispatch}, payload) {
      try{
        console.log(payload);
        dispatch("receivingMarketCampaign");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/insert/marketcampaign/' + payload.projectid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertProjectCampaignWithImageRequest({dispatch}, payload) {
      try{
        dispatch("receivingMarketCampaign");
        let token = localStorage.getItem('token');
        let url = 'https://api.tradexc.com:3000/insert/marketcampaign/withimage/' + payload.projectid;
        let data = new FormData();
        let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
  
        data.append('file', payload.imagefile, payload.imagename); 
        delete payload['imagefile'];
        for (let x in payload) data.append(x, payload[x]);
        
        let response = await axios({method: "post", url: url, headers: headers , data: data});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getMarketCampaignsRequest({dispatch}) {
      dispatch("receivingMarketCampaigns");
      let token = localStorage.getItem('token');
      console.log(token)
      let url = 'https://api.tradexc.com:3000/get/marketcampaigns';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url, headers: header})
      .then(response => {
        console.log(response.data);
        dispatch("receiveMarketCampaigns", response.data);
      })
    },
    async findMarketCampaignsRequest({dispatch}, payload) {
      dispatch("receivingMarketCampaigns");
      let token = localStorage.getItem('token');
      console.log(payload)
      let url = 'https://api.tradexc.com:3000/find/marketcampaigns';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "POST", url: url, headers: header, data: payload})
      .then(response => {
        dispatch("receiveMarketCampaigns", response.data);
      })
    },
    async updateMarketCampaignRequest({dispatch}, payload) {
      dispatch("updatingMarketCampaign");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/marketcampaign/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers, data: payload})
      .then((response)=> {
        dispatch("updateMarketCampaign", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    async updateMarketCampaignApproveRequest({dispatch}, payload) {
      dispatch("updatingMarketCampaign");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/marketcampaign/approve/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers, data: payload})
      .then((response)=> {
        dispatch("updateMarketCampaign", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    async updateProjectCampaignRequest({dispatch}, payload) {
      try{
        dispatch("updatingMarketCampaign");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/marketcampaign/' + payload.campaignid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("updateMarketCampaign", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateProjectCampaignWithImageRequest({dispatch}, payload) {
      try{
        dispatch("updatingMarketCampaign");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/marketcampaign/withimage/' + payload.campaignid;

        let data = new FormData();  
        data.append('file', payload.imagefile, payload.imagename); 
        delete payload['imagefile'];
        for (let x in payload) data.append(x, payload[x]);

        let response = await axios({method: "PUT", url: url, headers: headers, data: data});
        dispatch("updateMarketCampaign", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateMarketCampaignImageRequest({dispatch}, payload) {
      dispatch("updatingMarketCampaign");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];
      let url = 'https://api.tradexc.com:3000/update/marketcampaign/image/' + id;
      let data = new FormData();
      data.append('file', payload.imagefile, payload.imagename); 
      delete payload['imagefile'];
      for (let x in payload) data.append(x, payload[x])
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      return axios({method: "PUT", url: url, headers: headers, data: data})
      .then(response=>{
        dispatch("updateMarketCampaign", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    clearMarketCampaigns({commit}) {
      commit("CLEAR_MARKETCAMPAIGNS")
    },
    receiveMarketCampaigns({commit}, payload) {
      commit("RECEIVED_MARKETCAMPAIGNS", payload)
    },
    receivingMarketCampaigns({commit}) {
      commit("RECEIVING_MARKETCAMPAIGNS")
    },
    receiveMarketCampaign({commit}, payload) {
      commit("RECEIVED_MARKETCAMPAIGN", payload)
    },
    receivingMarketCampaign({commit}) {
      commit("RECEIVING_MARKETCAMPAIGN")
    },
    updateMarketCampaign({commit}, payload) {
      commit("UPDATED_MARKETCAMPAIGN", payload)
    },
    updatingMarketCampaign({commit}) {
      commit("UPDATING_MARKETCAMPAIGN")
    },
    deleteMarketCampaign({commit}, payload) {
      commit("DELETED_MARKETCAMPAIGN", payload)
    },
    deletingMarketCampaign({commit}, payload) {
      commit("DELETING_MARKETCAMPAIGN", payload)
    }
  },
};
